import { render, staticRenderFns } from "./GetPhotoExam.vue?vue&type=template&id=b944cb6a&scoped=true&"
import script from "./GetPhotoExam.vue?vue&type=script&lang=js&"
export * from "./GetPhotoExam.vue?vue&type=script&lang=js&"
import style0 from "./GetPhotoExam.vue?vue&type=style&index=0&id=b944cb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b944cb6a",
  null
  
)

export default component.exports